import { render, staticRenderFns } from "./kulutusluotto24.vue?vue&type=template&id=2b978b27&"
import script from "./kulutusluotto24.vue?vue&type=script&lang=js&"
export * from "./kulutusluotto24.vue?vue&type=script&lang=js&"
import style0 from "./kulutusluotto24.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports